import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { inventoryCheckService } from 'shared/services';
import InventoryCheckForm from '../components/InventoryCheckForm';
import { IInventoryCheck } from '../types';

const initInventory: IInventoryCheck = {
  id: null,
  code: '',
  warehouse: null,
  suppliers: [],
  locations: [],
  categories: [],
  date: null,
  partial: false
};

export const AddInventoryCheck = () => {
  const translationPrefix = 'pages.inventory-check.new';
  const { t } = useTranslation();
  const navigate = useNavigate();

  const createInventoryCheck = async (values) => {
    inventoryCheckService.initialize(values).then((res) => {
      if (res?.id) {
        navigate(`../${res.id}`);
      }
    });
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <InventoryCheckForm inventory={initInventory} onSubmit={createInventoryCheck} />
    </TenantPage>
  );
};

export default AddInventoryCheck;
